const setClassBasedOnCell = (value, coulumnData) => {
  switch (value) {
    case "ticketNumber":
    case "contractNumber":
      return value;
    case "contractStage":
    case "stage":
      return coulumnData[value];
    default:
      return "";
  }
};

export default setClassBasedOnCell;



// WEBPACK FOOTER //
// ./src/utils/ClassSetter.js